import { render } from "./ProjectSummaryComponent.vue?vue&type=template&id=4123d16a&scoped=true&ts=true"
import script from "./ProjectSummaryComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectSummaryComponent.vue?vue&type=script&lang=ts"

import "./ProjectSummaryComponent.vue?vue&type=style&index=0&id=4123d16a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4123d16a"]])

export default __exports__